export default "<div class=\"loading\" [class.loader-hidden]=\"!show\"></div>"